import {
  StyleSheet,
  Text,
  View,
  SafeAreaView,
  Image,
  TextInput,
  TouchableOpacity,
  KeyboardAvoidingView,
  Dimensions,
  ImageBackground,
  ScrollView,
  Modal,
  FlatList,
} from "react-native";
import React, { useState } from "react";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
import { useTranslation } from "react-i18next";
import Appstyles from "../../Constants/AppStyles";
import AppColors from "../../Constants/AppColors";
// import { Dropdown } from "react-native-element-dropdown";

//import App from "../../../App";
// import Dropblack, {
//   CusCategory,
//   CusOrganization,
//   Gender,
//   SpeedLimit,
// } from "../../Components/Dropblack.js";

const Registration = ({ navigation }) => {
  // const { t } = useTranslation();

  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
  const phoneRegex = /^\d{7,13}$/;
  const countryCodes = [
    { name: "United States", flag: "🇺🇸", code: "+1" },
    { name: "United Kingdom", flag: "🇬🇧", code: "+44" },
    { name: "Canada", flag: "🇨🇦", code: "+1" },
    { name: "Australia", flag: "🇦🇺", code: "+61" },
    { name: "India", flag: "🇮🇳", code: "+91" },
    { name: "Germany", flag: "🇩🇪", code: "+49" },
    { name: "France", flag: "🇫🇷", code: "+33" },
    { name: "Japan", flag: "🇯🇵", code: "+81" },
    { name: "Brazil", flag: "🇧🇷", code: "+55" },
    { name: "Mexico", flag: "🇲🇽", code: "+52" },
    { name: "Italy", flag: "🇮🇹", code: "+39" },
    { name: "Spain", flag: "🇪🇸", code: "+34" },
    { name: "Netherlands", flag: "🇳🇱", code: "+31" },
    { name: "Sweden", flag: "🇸🇪", code: "+46" },
    { name: "Switzerland", flag: "🇨🇭", code: "+41" },
    { name: "Belgium", flag: "🇧🇪", code: "+32" },
    { name: "Norway", flag: "🇳🇴", code: "+47" },
    { name: "Denmark", flag: "🇩🇰", code: "+45" },
    { name: "Finland", flag: "🇫🇮", code: "+358" },
    { name: "Austria", flag: "🇦🇹", code: "+43" },
    { name: "Greece", flag: "🇬🇷", code: "+30" },
    { name: "South Korea", flag: "🇰🇷", code: "+82" },
    { name: "Russia", flag: "🇷🇺", code: "+7" },
    { name: "China", flag: "🇨🇳", code: "+86" },
    { name: "Turkey", flag: "🇹🇷", code: "+90" },
    { name: "Argentina", flag: "🇦🇷", code: "+54" },
    { name: "Colombia", flag: "🇨🇴", code: "+57" },
    { name: "Chile", flag: "🇨🇱", code: "+56" },
    { name: "Peru", flag: "🇵🇪", code: "+51" },
    { name: "Egypt", flag: "🇪🇬", code: "+20" },
    { name: "Saudi Arabia", flag: "🇸🇦", code: "+966" },
    { name: "United Arab Emirates", flag: "🇦🇪", code: "+971" },
    { name: "South Africa", flag: "🇿🇦", code: "+27" },
    { name: "Nigeria", flag: "🇳🇬", code: "+234" },
    { name: "Kenya", flag: "🇰🇪", code: "+254" },
    { name: "Morocco", flag: "🇲🇦", code: "+212" },
    { name: "Portugal", flag: "🇵🇹", code: "+351" },
    { name: "Ireland", flag: "🇮🇪", code: "+353" },
    { name: "New Zealand", flag: "🇳🇿", code: "+64" },
    { name: "Singapore", flag: "🇸🇬", code: "+65" },
    { name: "Malaysia", flag: "🇲🇾", code: "+60" },
    { name: "Indonesia", flag: "🇮🇩", code: "+62" },
    { name: "Thailand", flag: "🇹🇭", code: "+66" },
    { name: "Philippines", flag: "🇵🇭", code: "+63" },
    { name: "Vietnam", flag: "🇻🇳", code: "+84" },
    { name: "Pakistan", flag: "🇵🇰", code: "+92" },
    { name: "Bangladesh", flag: "🇧🇩", code: "+880" },
    { name: "Sri Lanka", flag: "🇱🇰", code: "+94" },
    { name: "Myanmar", flag: "🇲🇲", code: "+95" },
  ];

  // const { t } = useTranslation(["common"]);
  const [customerName, setCustomerName] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerCity, setCustomerCity] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [selectedCapacity, setSelectedCapacity] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const [customerNameError, setCustomerNameError] = useState(false);
  const [customerAddressError, setCustomerAddressError] = useState(false);
  const [customerCityError, setCustomerCityError] = useState(false);
  const [customerEmailError, setCustomerEmailError] = useState(false);
  const [customerMobileError, setCustomerMobileError] = useState(false);
  const [countryErrorMessage, setCountryErrorMessage] = useState(false);
  const [capacityErrorMessage, setCapacityErrorMessage] = useState("");
  const [isSubmitTouched, setIsSubmitTouched] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [firstFieldModalVisible, setFirstFieldModalVisible] = useState(false);
  const [secondFieldModalVisible, setSecondFieldModalVisible] = useState(false);
  const [sharedCountryCode, setSharedCountryCode] = useState("");
  const [secondFieldCountryCode, setSecondFieldCountryCode] = useState("");
  const [searchText, setSearchText] = useState("");
  const [value, setValue] = useState("");
  const [isFocus, setIsFocus] = useState("");

  const TimeZoneData = [
    { label: "Europe/Andorra" },
    { label: "Asia/Dubai" },
    { label: "Asia/Kabul" },
    { label: "Europe/Tirane" },
    { label: "Asia/Yerevan" },
    { label: "America/New_York" },
    { label: "America/Los_Angeles" },
    { label: "Europe/London" },
    { label: "Asia/Tokyo" },
    { label: "Australia/Sydney" },
  ];

  const validateForm = () => {
    if (
      customerName &&
      customerAddress &&
      customerCity &&
      selectedCountry &&
      emailRegex.test(customerEmail) &&
      phoneRegex.test(customerMobile)
    ) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
      setCustomerNameError(!customerName);
      setCustomerAddressError(!customerAddress);
      setCustomerCityError(!customerCity && !customerCity.trim());
      setCustomerEmailError(!emailRegex.test(customerEmail));
      setCustomerMobileError(!phoneRegex.test(customerMobile));

      if (!selectedCountry) {
        setCountryErrorMessage("Please select a country");
      } else {
        setCountryErrorMessage("");
      }

      if (selectedCapacity === null) {
        setCapacityErrorMessage("Please select a capacity");
      } else {
        setCapacityErrorMessage("");
      }
    }
  };

  const handleSubmit = () => {
    setIsSubmitTouched(true);
    validateForm();
    if (isFormValid) {
      navigation.navigate("DrawerScreen");
    }
  };

  const getCountryNameFromCode = (code) => {
    const selectedCountry = countryCodes.find(
      (country) => country.code === code
    );
    return selectedCountry ? selectedCountry.name : "";
  };

  const getCountryFlagFromCode = (code) => {
    const selectedCountry = countryCodes.find(
      (country) => country.code === code
    );
    return selectedCountry ? selectedCountry.flag : "";
  };

  const handleSharedCountryCodeChange = (countryCode) => {
    setSharedCountryCode(countryCode);
    setSecondFieldCountryCode(countryCode);
    setSelectedCountry(countryCode);
  };

  const filteredCountryCodes = countryCodes.filter((country) =>
    country.name.toLowerCase().includes(searchText.toLowerCase())
  );
  const handlePress = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback to home or custom action
      window.location.href = "/";
    }
  };
  return (
    <SafeAreaView style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.headerLeft}>
          <TouchableOpacity style={styles.backButton} onPress={handlePress}>
            <Image source={AppImages.Backbtn} style={styles.backIcon} />
          </TouchableOpacity>
        </View>

        <Image source={AppImages.LoginLogo} style={styles.logo} />

        <View style={styles.headerRight} />
      </View>

      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.scrollContent}
      >
        <View style={styles.formContainer}>
          {/* Title */}
          <View style={styles.titleContainer}>
            <Text style={styles.title}>
              {/* {t("common:translation.Tell us about yourself")} */}
              Tell us about yourself
            </Text>
          </View>

          {/* Business Name */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Your Business Name
              {/* {t("common:translation.Your Business Name ")} */}
              <Text style={styles.required}>*</Text>
            </Text>
            <TextInput
              style={[
                styles.textInput,
                customerNameError && isSubmitTouched && styles.inputError,
              ]}
              onChangeText={(text) => {
                setCustomerName(text);
                validateForm();
              }}
              value={customerName}
              // placeholder={t(
              //   "common:translation.Enter your Business Name here..."
              // )}
              placeholderTextColor={AppColors.dualbrown}
            />
            {customerNameError && isSubmitTouched && (
              <Text style={styles.errorText}>
                Field is required
                {/* {t("common:translation.Field is required")} */}
              </Text>
            )}
          </View>

          {/* Address */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Address
              {/* {t("common:translation.Address ")} */}
              <Text style={styles.required}>*</Text>
            </Text>
            <TextInput
              style={[
                styles.textInput,
                styles.multilineInput,
                customerAddressError && isSubmitTouched && styles.inputError,
              ]}
              onChangeText={(text) => {
                setCustomerAddress(text);
                validateForm();
              }}
              value={customerAddress}
              // placeholder={t("common:translation.Enter your Address... ")}
              placeholder={"Enter your Address..."}
              placeholderTextColor={AppColors.dualbrown}
              multiline
              numberOfLines={4}
            />
            {customerAddressError && isSubmitTouched && (
              <Text style={styles.errorText}>
                Field is required
                {/* {t("common:translation.Field is required")} */}
              </Text>
            )}
          </View>

          {/* Email */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              {/* {t("common:translation.Email ID ")}yuiuyi */}
              Email ID
              <Text style={styles.required}>*</Text>
            </Text>
            <TextInput
              style={[
                styles.textInput,
                customerEmailError && isSubmitTouched && styles.inputError,
              ]}
              onChangeText={(text) => {
                setCustomerEmail(text);
                validateForm();
              }}
              value={customerEmail}
              // placeholder={t("common:translation.Enter you Email ID ")}
              placeholder={"translation.Enter you Email ID "}
              placeholderTextColor={AppColors.dualbrown}
              keyboardType="email-address"
              autoCapitalize="none"
            />
            {customerEmailError && isSubmitTouched && (
              <Text style={styles.errorText}>
                Field is required
                {/* {t("common:translation.Field is required")} */}
              </Text>
            )}
          </View>

          {/* Nationality */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Nationality <Text style={styles.required}>*</Text>
            </Text>
            <TouchableOpacity
              style={[
                styles.countrySelector,
                countryErrorMessage && styles.inputError,
              ]}
              onPress={() => setFirstFieldModalVisible(true)}
            >
              {sharedCountryCode ? (
                <Text style={styles.selectedCountry}>
                  {getCountryFlagFromCode(sharedCountryCode)}{" "}
                  {getCountryNameFromCode(sharedCountryCode)}
                </Text>
              ) : (
                <Text style={styles.placeholderText}>
                  Select Country
                  {/* {t("common:translation.Select Country")} */}
                </Text>
              )}
            </TouchableOpacity>
            {countryErrorMessage && (
              <Text style={styles.errorText}>{countryErrorMessage}</Text>
            )}
          </View>

          {/* Contact Number */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Contact Number
              <Text style={styles.required}> *</Text>
            </Text>
            <View style={styles.phoneInputContainer}>
              <TouchableOpacity
                style={styles.countryCodeButton}
                onPress={() => setSecondFieldModalVisible(true)}
              >
                <Text style={styles.countryCodeText}>
                  {secondFieldCountryCode || "+91"}
                </Text>
              </TouchableOpacity>
              <TextInput
                style={[
                  styles.phoneInput,
                  customerMobileError && isSubmitTouched && styles.inputError,
                ]}
                onChangeText={(text) => {
                  setCustomerMobile(text);
                  validateForm();
                }}
                value={customerMobile}
                placeholder={"common:translation.Enter your Contact Number"}
                // placeholder={t("common:translation.Enter your Contact Number")}
                placeholderTextColor={AppColors.dualbrown}
                keyboardType="phone-pad"
              />
            </View>
            {customerMobileError && isSubmitTouched && (
              <Text style={styles.errorText}>
                Field is required
                {/* {t("common:translation.Field is required")} */}
              </Text>
            )}
          </View>

          {/* City */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              {/* {t("common:translation.City ")} */}
              City
              <Text style={styles.required}>*</Text>
            </Text>
            <TextInput
              style={[
                styles.textInput,
                customerCityError && isSubmitTouched && styles.inputError,
              ]}
              onChangeText={(text) => {
                setCustomerCity(text);
                setCustomerCityError(false);
                validateForm();
              }}
              value={customerCity}
              // placeholder={t("common:translation.Enter a Location")}
              placeholder={"Enter a Location"}
              placeholderTextColor={AppColors.dualbrown}
            />
            {customerCityError && isSubmitTouched && (
              <Text style={styles.errorText}>
                Field is required
                {/* {t("common:translation.Field is required")} */}
              </Text>
            )}
          </View>

          {/* Time Zone */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Time Zone
              {/* {t("common:translation.Time Zone ")} */}
              <Text style={styles.required}>*</Text>
            </Text>
            {/* <Dropdown
              style={[styles.dropdown, isFocus && styles.dropdownFocus]}
              containerStyle={styles.dropdownContainer}
              itemTextStyle={styles.dropdownItemText}
              placeholderStyle={styles.dropdownPlaceholder}
              selectedTextStyle={styles.dropdownSelectedText}
              inputSearchStyle={styles.dropdownSearch}
              iconStyle={styles.dropdownIcon}
              data={TimeZoneData}
              search
              maxHeight={300}
              labelField="label"
              valueField="label"
              placeholder={t("common:translation.Select Time Zone...")}
              searchPlaceholder="Search..."
              value={value}
              onFocus={() => setIsFocus(true)}
              onBlur={() => setIsFocus(false)}
              onChange={(item) => {
                setValue(item.label);
                setSelectedCapacity(item.label);
                setIsFocus(false);
                validateForm();
              }}
              renderRightIcon={() => (
                <Image source={AppImages.Arrow} style={styles.dropdownArrow} />
              )}
            /> */}
            {capacityErrorMessage && (
              <Text style={styles.errorText}>{capacityErrorMessage}</Text>
            )}
          </View>

          {/* Customer Category */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Customer Category
              {/* {t("common:translation.Customer Category")} */}
            </Text>
            {/* <Dropblack
              data={CusCategory}
              placeholder="Select Your Category of Business"
            /> */}
          </View>

          {/* Customer Organization Type */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Customer Organization Type
              {/* {t("common:translation.Customer Organization Type")} */}
            </Text>
            {/* <Dropblack
              data={CusOrganization}
              placeholder="Select Organization"
            /> */}
          </View>

          {/* Business Domain */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Customer Business Domain name
              {/* {t("common:translation.Customer Business Domain name")} */}
            </Text>
            {/* <Dropblack
              data={CusOrganization}
              placeholder="Select your Business Domain"
            /> */}
          </View>

          {/* Website */}
          <View style={styles.inputContainer}>
            <Text style={styles.label}>
              Website
              {/* {t("common:translation.Website")} */}
            </Text>
            <TextInput
              style={styles.textInput}
              // placeholder={t("common:translation.Enter URL of your website...")}
              placeholder={"Enter URL of your website..."}
              placeholderTextColor={AppColors.dualbrown}
              keyboardType="url"
              autoCapitalize="none"
            />
          </View>

          {/* Submit Button */}
          <TouchableOpacity
            style={[
              styles.submitButton,
              !isFormValid && styles.submitButtonDisabled,
            ]}
            onPress={handleSubmit}
            disabled={!isFormValid}
          >
            <Text style={styles.submitButtonText}>
              Save & Proceed
              {/* {t("common:translation.Save & Proceed")} */}
            </Text>
          </TouchableOpacity>
        </View>
      </ScrollView>

      {/* Country Selection Modals */}
      <Modal visible={firstFieldModalVisible} transparent animationType="slide">
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <TextInput
              style={styles.searchInput}
              placeholder="Search Country"
              value={searchText}
              onChangeText={setSearchText}
              placeholderTextColor={AppColors.dualbrown}
            />
            <FlatList
              data={filteredCountryCodes}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={styles.countryItem}
                  onPress={() => {
                    handleSharedCountryCodeChange(item.code);
                    setFirstFieldModalVisible(false);
                    setSearchText("");
                  }}
                >
                  <Text style={styles.countryFlag}>{item.flag}</Text>
                  <Text style={styles.countryName}>{item.name}</Text>
                  <Text style={styles.countryCode}>{item.code}</Text>
                </TouchableOpacity>
              )}
              keyExtractor={(item) => item.code}
            />
            <TouchableOpacity
              style={styles.modalCloseButton}
              onPress={() => {
                setFirstFieldModalVisible(false);
                setSearchText("");
              }}
            >
              <Text style={styles.modalCloseText}>Close</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      <Modal
        visible={secondFieldModalVisible}
        transparent
        animationType="slide"
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <TextInput
              style={styles.searchInput}
              placeholder="Search Country"
              value={searchText}
              onChangeText={setSearchText}
              placeholderTextColor={AppColors.dualbrown}
            />
            <FlatList
              data={filteredCountryCodes}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={styles.countryItem}
                  onPress={() => {
                    setSecondFieldCountryCode(item.code);
                    setSecondFieldModalVisible(false);
                    setSearchText("");
                  }}
                >
                  <Text style={styles.countryFlag}>{item.flag}</Text>
                  <Text style={styles.countryName}>{item.name}</Text>
                  <Text style={styles.countryCode}>{item.code}</Text>
                </TouchableOpacity>
              )}
              keyExtractor={(item) => item.code}
            />
            <TouchableOpacity
              style={styles.modalCloseButton}
              onPress={() => {
                setSecondFieldModalVisible(false);
                setSearchText("");
              }}
            >
              <Text style={styles.modalCloseText}>Close</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

export default Registration;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AppColors.sandal,
  },
  header: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 10,
  },
  headerLeft: {
    flex: 1,
    alignItems: "flex-start",
  },
  headerRight: {
    width: 40,
  },
  backButton: {
    padding: 10,
  },
  backIcon: {
    width: 8,
    height: 15,
    resizeMode: "contain",
  },
  logo: {
    width: 120,
    height: 36,
    resizeMode: "contain",
  },
  scrollContent: {
    flexGrow: 1,
  },
  formContainer: {
    margin: 20,
    paddingVertical: 20,
    backgroundColor: AppColors.white,
    borderRadius: 10,
  },
  titleContainer: {
    borderBottomColor: "#ACACAC",
    borderBottomWidth: 0.5,
    marginHorizontal: 20,
    paddingBottom: 10,
  },
  title: {
    textAlign: "center",
    fontSize: 18,
    fontFamily: AppFonts.OverpassSemiBold,
    color: AppColors.brown,
  },
  inputContainer: {
    marginTop: 20,
  },
  label: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown,
    marginLeft: 20,
    marginBottom: 5,
  },
  required: {
    color: AppColors.red,
  },
  textInput: {
    borderWidth: 1,
    borderColor: "#F6EFE9",
    borderRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 12,
    marginHorizontal: 20,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    backgroundColor: AppColors.white,
  },
  multilineInput: {
    height: 100,
    textAlignVertical: "top",
  },
  phoneInputContainer: {
    flexDirection: "row",
    marginHorizontal: 20,
  },
  countryCodeButton: {
    borderWidth: 1,
    borderColor: "#F6EFE9",
    borderRightWidth: 0,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 12,
    backgroundColor: AppColors.white,
    justifyContent: "center",
  },
  countryCodeText: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },
  phoneInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#F6EFE9",
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 12,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    backgroundColor: AppColors.white,
  },
  countrySelector: {
    borderWidth: 1,
    borderColor: "#F6EFE9",
    borderRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 12,
    marginHorizontal: 20,
    backgroundColor: AppColors.white,
  },
  selectedCountry: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },
  placeholderText: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  dropdown: {
    borderColor: "#F6EFE9",
    borderWidth: 1,
    borderRadius: 10,
    marginHorizontal: 20,
    paddingVertical: 12,
    marginTop: 7,
    backgroundColor: AppColors.white,
  },
  dropdownFocus: {
    borderColor: AppColors.brown,
  },
  dropdownContainer: {
    backgroundColor: AppColors.white,
    borderColor: "#F6EFE9",
    borderWidth: 1,
    borderRadius: 10,
  },
  dropdownItemText: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },
  dropdownPlaceholder: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
    paddingLeft: 15,
  },
  dropdownSelectedText: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    paddingLeft: 15,
  },
  dropdownSearch: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    paddingLeft: 15,
  },
  dropdownIcon: {
    width: 20,
    height: 20,
  },
  dropdownArrow: {
    height: 12,
    width: 15,
    marginRight: 10,
  },
  submitButton: {
    backgroundColor: AppColors.brown,
    marginHorizontal: 20,
    marginTop: 30,
    marginBottom: 10,
    paddingVertical: 15,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  submitButtonDisabled: {
    backgroundColor: "#8F430080",
  },
  submitButtonText: {
    color: AppColors.white,
    fontSize: 16,
    fontFamily: AppFonts.OverpassSemiBold,
  },
  inputError: {
    borderColor: AppColors.red,
  },
  errorText: {
    color: AppColors.red,
    marginRight: 20,
    fontSize: 10,
    fontFamily: AppFonts.OverpassRegular,
    textAlign: "right",
    marginTop: 5,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: 10,
    padding: 20,
    width: "90%",
    maxHeight: "80%",
  },
  searchInput: {
    fontSize: 16,
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
    borderRadius: 10,
    borderColor: AppColors.brown,
    borderWidth: 1,
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 15,
  },
  countryItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#F6EFE9",
  },
  countryFlag: {
    fontSize: 20,
    marginRight: 10,
    width: 30,
  },
  countryName: {
    flex: 1,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },
  countryCode: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  modalCloseButton: {
    marginTop: 15,
    paddingVertical: 12,
    alignItems: "center",
    borderTopWidth: 1,
    borderTopColor: "#F6EFE9",
  },
  modalCloseText: {
    fontSize: 16,
    fontFamily: AppFonts.OverpassSemiBold,
    color: AppColors.brown,
  },
});
